/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetOlafReprocessJobStatusByOrderIdQueryResponse, AuditReportsGetOlafReprocessJobStatusByOrderIdPathParams, AuditReportsGetOlafReprocessJobStatusByOrderId401, AuditReportsGetOlafReprocessJobStatusByOrderId403, AuditReportsGetOlafReprocessJobStatusByOrderId404 } from "../models/AuditReportsGetOlafReprocessJobStatusByOrderId";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { auditReportsGetOlafReprocessJobStatusByOrderId } from "../axios/auditReportsGetOlafReprocessJobStatusByOrderId";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const auditReportsGetOlafReprocessJobStatusByOrderIdQueryKey = (orderId: AuditReportsGetOlafReprocessJobStatusByOrderIdPathParams["orderId"]) => ["api-v2", { url: '/audit-reports/v1/olaf/reprocess/job-status-by-order/:orderId', params: {orderId:orderId} }] as const

export type AuditReportsGetOlafReprocessJobStatusByOrderIdQueryKey = ReturnType<typeof auditReportsGetOlafReprocessJobStatusByOrderIdQueryKey>

export function auditReportsGetOlafReprocessJobStatusByOrderIdQueryOptions(orderId: AuditReportsGetOlafReprocessJobStatusByOrderIdPathParams["orderId"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = auditReportsGetOlafReprocessJobStatusByOrderIdQueryKey(orderId)
        return queryOptions<AuditReportsGetOlafReprocessJobStatusByOrderIdQueryResponse, ResponseErrorConfig<AuditReportsGetOlafReprocessJobStatusByOrderId401 | AuditReportsGetOlafReprocessJobStatusByOrderId403 | AuditReportsGetOlafReprocessJobStatusByOrderId404>, AuditReportsGetOlafReprocessJobStatusByOrderIdQueryResponse, typeof queryKey>({
         enabled: !!(orderId),
         queryKey,
         queryFn: async ({ signal }) => {
            return auditReportsGetOlafReprocessJobStatusByOrderId(orderId, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Finds and returns the most recent reprocess job for the given order ID(s) within the user's client. The provided orders must exactly match the orders in the job.
 * @summary Get OLAF reprocess job status by order ID
 * {@link /audit-reports/v1/olaf/reprocess/job-status-by-order/:orderId}
 */
export function useAuditReportsGetOlafReprocessJobStatusByOrderId<TData = AuditReportsGetOlafReprocessJobStatusByOrderIdQueryResponse, TQueryData = AuditReportsGetOlafReprocessJobStatusByOrderIdQueryResponse, TQueryKey extends QueryKey = AuditReportsGetOlafReprocessJobStatusByOrderIdQueryKey>(orderId: AuditReportsGetOlafReprocessJobStatusByOrderIdPathParams["orderId"], options: 
{
  query?: Partial<QueryObserverOptions<AuditReportsGetOlafReprocessJobStatusByOrderIdQueryResponse, ResponseErrorConfig<AuditReportsGetOlafReprocessJobStatusByOrderId401 | AuditReportsGetOlafReprocessJobStatusByOrderId403 | AuditReportsGetOlafReprocessJobStatusByOrderId404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? auditReportsGetOlafReprocessJobStatusByOrderIdQueryKey(orderId)
         

         const query = useQuery({
          ...auditReportsGetOlafReprocessJobStatusByOrderIdQueryOptions(orderId, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AuditReportsGetOlafReprocessJobStatusByOrderId401 | AuditReportsGetOlafReprocessJobStatusByOrderId403 | AuditReportsGetOlafReprocessJobStatusByOrderId404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}